export enum RewardRule {
  RR_UNSET = 'RR_UNSET', // Do not use, needed because of proto3 limitations
  RR_NONE = 'RR_NONE',
  RR_POST_POS_ACTIVATION = 'RR_POST_POS_ACTIVATION',
}
